import { createFileRoute } from '@tanstack/react-router'
import AdminHomePage from '@/components/pages/Admin/AdminHomePage/AdminHomePage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/home')({
  component: AdminHomeRoute,
})

function AdminHomeRoute() {
  return <AdminHomePage />
}
